import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Só ativa em telas < 1024px
    this.handleClickOutside = this.handleClickOutside.bind(this);
    document.addEventListener('click', this.handleClickOutside);
    
    // Gerenciar visibilidade do botão sanduíche
    this.setupSandwichButtonManager();
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside);
    
    // Limpar observer do botão sanduíche
    if (this.sidebarObserver) {
      this.sidebarObserver.disconnect();
      this.sidebarObserver = null;
    }
  }

  handleClickOutside(event) {
    // Só funciona em telas < 1024px
    if (window.innerWidth >= 1024) return;
    
    const sidebar = document.getElementById('drawer-navigation');
    if (!sidebar) return;
    
    // Verifica se o sidebar está aberto (sem classe hidden)
    const isOpen = !sidebar.classList.contains('hidden');
    if (!isOpen) return;
    
    // Verifica se clicou no botão toggle (sanduíche) - NÃO interceptar
    const clickedToggle = event.target.closest('[data-action*="slideover#toggle"]');
    if (clickedToggle) return; // Deixa o slideover lidar com isso
    
    // Verifica se clicou dentro do sidebar
    const clickedSidebar = event.target.closest('#drawer-navigation');
    if (clickedSidebar) return;
    
    // Clicou fora do sidebar - fecha usando o slideover controller
    this.closeSidebar();
  }

  closeSidebar() {
    // Usa o slideover controller para fechar
    const slideoverElement = document.querySelector('[data-controller*="slideover"]');
    if (slideoverElement) {
      // Dispara evento para fechar via slideover
      const hideEvent = new Event('click');
      Object.defineProperty(hideEvent, 'target', {
        value: document.body,
        enumerable: true
      });
      window.dispatchEvent(hideEvent);
    }
  }

  setupSandwichButtonManager() {
    const sidebar = document.getElementById('drawer-navigation');
    if (!sidebar) return;
    
    // Observer para mudanças no sidebar
    if (this.sidebarObserver) {
      this.sidebarObserver.disconnect();
    }
    
    this.sidebarObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          this.updateSandwichButtonVisibility();
        }
      });
    });
    
    this.sidebarObserver.observe(sidebar, { 
      attributes: true, 
      attributeFilter: ['class'] 
    });
    
    // Estado inicial
    this.updateSandwichButtonVisibility();
  }

  updateSandwichButtonVisibility() {
    // Só funciona em telas < 1024px
    if (window.innerWidth >= 1024) return;
    
    const sandwichButton = document.getElementById('map-menu-button');
    const sidebar = document.getElementById('drawer-navigation');
    const navbar = document.querySelector('nav');
    
    if (!sandwichButton || !sidebar) return;
    
    const sidebarAberto = !sidebar.classList.contains('hidden');
    const temNavbar = navbar && navbar.style.display !== 'none';
    
    // Só esconde o botão se não tem navbar (ViewMap) e sidebar está aberto
    if (!temNavbar && sidebarAberto) {
      this.hideSandwichButton(sandwichButton);
    } else {
      this.showSandwichButton(sandwichButton);
    }
  }

  hideSandwichButton(button) {
    // Remove bruscamente - sem animação
    button.style.transition = 'none';
    button.style.opacity = '0';
    button.style.visibility = 'hidden';
    button.style.pointerEvents = 'none';
  }

  showSandwichButton(button) {
    // Aparece com animação suave
    button.style.transition = 'all 0.3s ease-in-out';
    button.style.opacity = '1';
    button.style.visibility = 'visible';
    button.style.pointerEvents = 'auto';
  }
}